export class LocalizationModel {
  supplier: string = 'Supplier';
  suppliers: string = 'Suppliers';
  order: string = 'Order';
  orders: string = 'Orders'
  availability: string = 'Availability';
  product: string = 'Product';
  products: string = 'Products';
  agent: string = 'Agent';
  delivery: string = 'Delivery';
  category: string = 'Category';
  viewDetail: string = 'View Details';
  emptyCartMsg: string = "There is nothing in your bag. Let's add some items.";
  track: string = 'Track';
  categories: string = 'Categories';
  brand: string = "Brand"
  brands: string = "Brands";
  payment: string = 'Payment';
  cash: string = 'Cash';
  total_revenue: string = 'Total Revenue';
  prescription_value: string = 'Prescription';
  instruction: string = 'Instructions';
  product_file_upload: string = 'Download Recipe';
  search_for: string = 'Search For';
  unserviceable: string = 'Unserviceable'
  recommended_supplier: string = '';
  complete_address: string = 'Complete Address';
  tax: string = 'Tax';
  tip: string = 'Tip';
  wishlist: string = 'Wishlist';
  top_suppliers_near_you: string = '';
  choose_supplier: string = '';
  suppliers_near_you: string = '';
  download_app_text: string = 'para una mejor experincia discarga el app';
  login: string = 'Login';
  select_prescription_to_upload: string = 'Select prescription to upload';
  nationality: string = 'Nationality';
  done: string = 'Done';
  supplier_service_fee: string = 'Supplier Service Fee';
  timings: string = 'Timings';
  wallet: string = 'Wallet';
  loyalty_points: string = "Loyalty Programs";
  my_subscription: string = "My Subscription";
  subscription: string = 'Subscription';
  subscription_plans: string = 'Subscription Plans';
  cuisines: string = 'Cuisines';
  popular_brands: string = 'Popular Brands'
  license_number: string = 'License Number';
  popular_products: string = 'Popular Products';
  recently_viewed_products: string = 'Recently Viewed Products';
  what_are_u_looking_for: string = "What are you looking for";
  best_sellers: string = "Best Sellers"
  cod: string = 'Cash On Delivery';
  selfpickup: string = 'Self Pick-Up';
  customizable: string = 'Customizable';
  special_offers: string = 'Special Offers';
  tags: string = "Tags";
  flavor_of_the_week: string = "Flavor of the Week";
  become_a_flavor: string = "Become a Flavor";
  top_selling_items: string = "Top-Selling Dishes";
  preparation_time: string = 'Preparation Time';
  terms_and_conditions: string = 'Terms And Conditions';
  privacy_policy: string = 'Privacy Policy';
  about_us: string = 'About Us';
  faq: string = 'FAQ';
  cash_on_pickup: string = 'Cash On Pickup';

}
